import { Subject } from "@carnegie-learning/cure-types";
import { Action, createReducer, on } from "@ngrx/store";
import * as subjectActions from "../actions/student-active-subjects.action";

export interface StudentActiveSubjectsState {
    entities: Map<string, Subject>;
    loading: boolean;
    loaded: boolean;
}

export const initialState: StudentActiveSubjectsState = {
    entities: new Map<string, Subject>(),
    loading: false,
    loaded: false
};

const subjectReducer = createReducer(
    initialState,
    on(subjectActions.LoadStudentActiveSubjects, state => {
        return {
            ...state,
            loading: true,
            loaded: false
        };
    }),
    on(subjectActions.LoadStudentActiveSubjectsFail, state => {
        return {
            ...state,
            loading: false,
            loaded: false
        };
    }),
    on(subjectActions.LoadStudentActiveSubjectsSuccess, (state, { payload }) => {
        const activeSubjects = payload.data;
        const entities = new Map<string, Subject>();
        activeSubjects.forEach(activeSubject => {
            entities.set(activeSubject.subjectId, activeSubject);
        });
        return {
            ...state,
            loading: false,
            loaded: true,
            entities
        };
    })
);

export function reducer(state: StudentActiveSubjectsState | undefined, action: Action) {
    return subjectReducer(state, action);
}

export const getActiveSubjectsEntities = (state: StudentActiveSubjectsState) =>
    state.entities;
export const getActiveSubjectsLoading = (state: StudentActiveSubjectsState) =>
    state.loading;
export const getActiveSubjectsLoaded = (state: StudentActiveSubjectsState) =>
    state.loaded;
